import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import './HomePage.css';
import './LoadsheetPage.css';
import TopNav from "../components/TopNav";

const LoadsheetPage = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loadsheetData, setLoadsheetData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        // Check if we have loadsheet data in the location state
        if (location.state && location.state.loadsheetData) {
            setLoadsheetData(location.state.loadsheetData);
            console.log("Loadsheet data received from state:", location.state.loadsheetData);
        
            // Check if we have origin and destination in URL params
            // const orig = searchParams.get('orig');
            // const dest = searchParams.get('dest');
            // const eqpt = searchParams.get('eqpt') || '';
            // const kg = searchParams.get('kg') || '0';
            const orig = location.state.loadsheetData.orig;
            const dest = location.state.loadsheetData.dest;
            const eqpt = location.state.loadsheetData.eqpt;
            const kg = location.state.loadsheetData.kg;
            const jumpseat = location.state.loadsheetData.jumpseat;
            
            if (orig && dest) {
                fetchLoadsheetData(orig, dest, eqpt, kg, jumpseat);
            } else {
                console.log("No loadsheet data received and no params in URL");
            }
        }
    }, [location, searchParams]);
    
    const fetchLoadsheetData = async (orig, dest, eqpt, kg, jumpseat) => {
        setLoading(true);
        setError(null);
        
        try {

            const response = await axios.get("/api/routes/loadsheet", {
            params: { _t: Date.now(),  orig: orig, dest: dest, eqpt: eqpt, kg:kg, jumpseat: jumpseat }
            });                                
            const data = response.data;
            
            if (data.success) {
                setLoadsheetData({
                    orig: orig,
                    dest: dest,
                    eqpt: eqpt || data.data.aircraft.type,
                    kg: kg,
                    jumpseat: jumpseat,
                    ...data.data
                });
                console.log("Loadsheet data fetched from API:", data);
            } else {
                setError(data.message || "Failed to load data");
                console.error("API error:", data.message);
            }
        } catch (err) {
            setError("Error fetching loadsheet data");
            console.error("Fetch error:", err);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode}/>
            <div className={`loadsheet-container ${props.darkmode ? 'dark-theme' : 'light-theme'}`}>
                <div className="loadsheet-header">
                    <h1>Flight Loadsheet</h1>
                    <button
                        className="btn-back"
                        onClick={() => navigate('/routes', {
                            state: {
                                restoreResults: true,
                                orig: loadsheetData?.orig,
                                dest: loadsheetData?.dest
                            }
                        })}
                    >
                        <span className="btn-icon">←</span>
                        Back to Routes
                    </button>
                </div>
                
                {loading ? (
                    <div className="loadsheet-loading">
                        <p>Loading loadsheet data...</p>
                    </div>
                ) : error ? (
                    <div className="loadsheet-error">
                        <p>Error: {error}</p>
                        <p>Please try again or generate a loadsheet from the route details page.</p>
                    </div>
                ) : loadsheetData ? (
                    <div className="loadsheet-content">

                        

                        
                       
                        <div className="loadsheet-section">

                            <div className="loadsheet-preformatted">
                                <pre>{loadsheetData.text?.infoblock}</pre>
                            </div>
                        </div>
                        

                    </div>
                ) : (
                    <div className="loadsheet-error">
                        <p>No loadsheet data available. Please generate a loadsheet from the route details page.</p>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default LoadsheetPage;